export const MONITORING_BID = 'i18n_ecom_ticket';
export const TICKET_APP = 'ticket_email_pc';
export const MONITOR_SCHEMA_VERSION = '1';

export const MONITORING_CONTEXT = {
  ticket_app: TICKET_APP,
  monitor_schema_version: MONITOR_SCHEMA_VERSION
} as const;

export const MONITORING_EVENT = {
  apiResult: 'ticket_email_api_result',
  dependencyResult: 'ticket_email_dependency_result',
  blankScreenErrorBoundary: 'ticket_email_blank_screen_error_boundary',
  bssdkCaptchaUnavailable: 'ticket_email_bssdk_captcha_unavailable',
  bssdkCaptchaInitError: 'ticket_email_bssdk_captcha_init_error',
  bssdkCaptchaRecovered: 'ticket_email_bssdk_captcha_recovered',
  bssdkInitError: 'ticket_email_bssdk_init_error',
  bssdkUnsupportedIdc: 'ticket_email_bssdk_unsupported_idc',
  bssdkInitSuccess: 'ticket_email_bssdk_init_success',
  changeLanguageFailed: 'ticket_email_change_language_failed',
  switchLanguageDropdownLoadFailed: 'ticket_email_switch_lang_dropdown_load_failed'
} as const;

export type MonitoringEventName = (typeof MONITORING_EVENT)[keyof typeof MONITORING_EVENT];

export const BSSDK_EVENT_NAMES = [
  MONITORING_EVENT.bssdkCaptchaUnavailable,
  MONITORING_EVENT.bssdkCaptchaInitError,
  MONITORING_EVENT.bssdkCaptchaRecovered,
  MONITORING_EVENT.bssdkInitError,
  MONITORING_EVENT.bssdkUnsupportedIdc,
  MONITORING_EVENT.bssdkInitSuccess
] as const;

export type BssdkEventName = (typeof BSSDK_EVENT_NAMES)[number];

export const LANGUAGE_EVENT_NAMES = [
  MONITORING_EVENT.changeLanguageFailed,
  MONITORING_EVENT.switchLanguageDropdownLoadFailed
] as const;

export type LanguageEventName = (typeof LANGUAGE_EVENT_NAMES)[number];

export const LEGACY_EVENT_MIGRATION = {
  slardar_call_failed: { action: 'remove', target: null },
  ticket_email_starling_load_failed: {
    action: 'modify',
    target: MONITORING_EVENT.dependencyResult
  },
  get_email_lang_map_parse_error: {
    action: 'modify',
    target: MONITORING_EVENT.dependencyResult
  },
  get_email_lang_map_fetch_error: {
    action: 'modify',
    target: MONITORING_EVENT.dependencyResult
  },
  contact_us_json_stringify_error: { action: 'remove', target: null },
  contact_us_json_parse_error: { action: 'remove', target: null },
  contact_us_submit_request_fail: {
    action: 'modify',
    target: MONITORING_EVENT.apiResult
  },
  contact_us_submit_try_catch: {
    action: 'modify',
    target: 'captureException'
  },
  contact_us_submit_validate_catch: {
    action: 'modify',
    target: MONITORING_EVENT.apiResult
  },
  contact_us_faq_empty: {
    action: 'modify',
    target: MONITORING_EVENT.apiResult
  },
  ticket_email_bssdk_captcha_unavailable: {
    action: 'keep',
    target: MONITORING_EVENT.bssdkCaptchaUnavailable
  },
  ticket_email_bssdk_captcha_init_error: {
    action: 'keep',
    target: MONITORING_EVENT.bssdkCaptchaInitError
  },
  ticket_email_bssdk_captcha_recovered: {
    action: 'keep',
    target: MONITORING_EVENT.bssdkCaptchaRecovered
  },
  ticket_email_bssdk_init_error: {
    action: 'keep',
    target: MONITORING_EVENT.bssdkInitError
  },
  ticket_email_bssdk_unsupported_idc: {
    action: 'keep',
    target: MONITORING_EVENT.bssdkUnsupportedIdc
  },
  ticket_email_bssdk_init_success: {
    action: 'keep',
    target: MONITORING_EVENT.bssdkInitSuccess
  },
  ticket_email_blank_screen_error_boundary: {
    action: 'keep',
    target: MONITORING_EVENT.blankScreenErrorBoundary
  },
  ticket_email_change_language_failed: {
    action: 'keep',
    target: MONITORING_EVENT.changeLanguageFailed
  },
  ticket_email_switch_lang_dropdown_load_failed: {
    action: 'keep',
    target: MONITORING_EVENT.switchLanguageDropdownLoadFailed
  }
} as const;

